// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Text Extraction Processing node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { TextExtractionAdminView } from './components/AdminView'
import { TextExtractionWorkflowNode } from './components/WorkflowNode'

registerPipelineNode({
  id: 'processing.text_extraction',
  manifest: {
    id: 'processing.text_extraction',
    name: 'Text Extraction',
    category: 'processing',
    icon: 'FileText',
    description: 'Extract text from PDFs and documents with per-page tracking',
    order: 10,
  },
  WorkflowNode: TextExtractionWorkflowNode,
  AdminConfig: TextExtractionAdminView,
})
